module.exports = __webpack_public_path__ + "img/shape.2764277e.svg";